import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PolicyType {
  id: string;
  name: string;
  description: string | null;
  policy_line_id: string | null;
  sort_order: number | null;
  created_at?: string;
  updated_at?: string;
}

export const usePolicyTypes = () => {
  return useQuery({
    queryKey: ['policyTypes'],
    queryFn: async (): Promise<PolicyType[]> => {
      console.log("Fetching policy types..."); 
      const { data, error } = await supabase
        .from('policy_types')
        .select('*')
        .order('sort_order', { ascending: true });

      if (error) {
        console.error('Error fetching policy types:', error);
        throw error;
      }

      console.log("Fetched policy types:", data);
      return data || [];
    }
  });
};